import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import { CardSection } from "cxa-components";
import { Link } from "react-router-dom";
import AccountSummaries from "./widgets/AccountSummariesPP";
import withMatchMediaProps from "@hocs/with-match-media-props";
import Wallet from "./Wallet";
import SOAPopup from "./widgets/SOAPopup";
import UpArrow from "../common/ArrowUp";
import DownArrow from "../common/ArrowDown";
import TransactionList from "./TransactionList";
import messages from "components/messagesDescription";
import moment from "moment";

const ClaimAccountsDetail = ({ intl, account, uiConfigs, isNarrowScreen }) => {
  const [showMore, setShowMore] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const toggleShowMore = e => {
    e.preventDefault();
    setShowMore(!showMore);
  };
  return (
    <div className="claim-account-container">
      <CardSection>
        <button className="link" onClick={toggleShowMore}>
          <span>
            <strong>
              {intl.formatMessage({
                id: account.nameForEmployee,
                defaultMessage: account.nameForEmployee,
              })}{" "}
              ({account.currency})
            </strong>
          </span>
          <span style={{ marginLeft: "5px" }}>
            {showMore ? (
              <UpArrow width="14px" height="14px" />
            ) : (
              <DownArrow width="16px" height="16px" />
            )}
          </span>
        </button>
      </CardSection>
      <Wallet account={account} />

      {showMore && (
        <div style={{ padding: "10px" }}>
          <div>
            {
              <table className="table--minimal">
                <tbody>
                  <tr>
                    <th>{intl.formatMessage(messages.periodDescription)}:</th>
                    <td>
                      <strong>{`${moment(account.periodStart).format()} - ${moment(
                        account.periodEnd
                      ).format()}`}</strong>
                    </td>
                  </tr>
                  <tr>
                    <th>{intl.formatMessage(messages.statementDateDescription)}:</th>
                    <td>
                      <strong>{moment(new Date()).format()}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            }
          </div>
          <AccountSummaries account={account} uiConfigs={uiConfigs} />
          <div dangerouslySetInnerHTML={{ __html: account.soaRemarks }} />
          {account.soaPopUpLinkText && (
            <Fragment>
              <Link
                to="/"
                onClick={() => {
                  setShowPopup(true);
                }}
              >
                {account.soaPopUpLinkText}
              </Link>
              <SOAPopup
                isOpen={showPopup}
                closePopup={() => {
                  setShowPopup(true);
                }}
                planYear={account.benefitPeriod}
                accountType={account.accountType}
                currency={account.currency}
              />
            </Fragment>
          )}
          <TransactionList account={account} hideCurrency={true} />
        </div>
      )}
    </div>
  );
};

ClaimAccountsDetail.propTypes = {
  account: PropTypes.object,
  uiConfigs: PropTypes.object,
  intl: intlShape.isRequired,
  isNarrowScreen: PropTypes.bool,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(injectIntl(ClaimAccountsDetail));



// WEBPACK FOOTER //
// ./components/claim/ClaimAccountDetail.js